// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AiToAiCallResponse, TestCallDatenAiToAi } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useAiToAiCall(): (
  requestBody: TestCallDatenAiToAi
) => Promise<AiToAiCallResponse> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) => (await getAPI()).calls.aiToAiCall({ requestBody }),
    [getAPI]
  );
}
